import axios from "axios";

import settings from "config/baseSettings";
import store from "../redux/store";
// Import the action type only (not the action-creator module) to avoid a
// circular import: user.actions.js imports axios instances from 'services'.
import { UserActionTypes } from "../redux/user/user.types";

class AxiosServiceForm {
  axiosInstance = {};

  constructor() {
    this.initInstance();
  }

  initInstance() {
    this.axiosInstance = axios.create({
      baseURL: settings.baseUrl,
      // Auth is cookie-based (httpOnly adminAccessToken cookie) — the
      // browser attaches it automatically.
      withCredentials: true,
    });

    this.axiosInstance.interceptors.request.use((config) => {
      config.headers["Content-Type"] = "multipart/form-data";
      return config;
    });

    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          store.dispatch({ type: UserActionTypes.SIGN_OUT });
          if (
            typeof window !== "undefined" &&
            window.location.pathname !== "/"
          ) {
            window.location.assign("/");
          }
        }
        return Promise.reject(error);
      }
    );

    return this.axiosInstance;
  }

  getInstance() {
    return this.axiosInstance || this.initInstance();
  }
}

export default new AxiosServiceForm();
